module.exports = "/dist/2bc37d86a4ba12ce526c4af904a9946e.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-600italic.woff
// module id = 130
// module chunks = 0